import { PUBLIC_IDM_API_URL_ENV } from 'tools/environments';
import { GetSigninResponse } from './types';

type ProvideType = 'email' | 'mobile';

export const getProvide = async (type: ProvideType, lang = 'en') => {
	const search = window.location.search;
	const queryParams = [`culture=${lang}`];
	if (search) queryParams.push(search.slice(1));

	return fetch(`${PUBLIC_IDM_API_URL_ENV}/signin/provide-${type}?${queryParams.join('&')}`, {
		method: 'GET',
		credentials: 'include',
	})
	.then((res) => {
		if (res.ok) return res.json() as Promise<GetSigninResponse>;
	})
	.catch((error) => {
		console.error('Get provide email request error: ', error);
		throw error;
	});
};
